const EMAIL_EVENT_TYPE_OVERRIDES: Record<string, string> = {
    'ccruciani44@gmail.com': 'videoconsulto-holifya',
    'eleonoraluvara.nutrizionista@gmail.com': 'videoconsulto-holifya',
    'tsimbatatiana@gmail.com': 'videoconsulto-holifya',
    'elvira.pistolesi@holifya.com': 'consulto-nutrigenetico',
};

export const getEventTypeByRole = (email?: string): string => {
    if (email && EMAIL_EVENT_TYPE_OVERRIDES[email]) {
        return EMAIL_EVENT_TYPE_OVERRIDES[email];
    }
    return '30min';
};
